import { toast as e } from "../../components/toast.mjs";
import { useTranslation as t } from "../../i18n.mjs";
import { ImageModeEnum as n } from "./image-enum.mjs";
import { ToolbarButton as r } from "../../components/content-controls/toolbar-button.mjs";
import { ToolbarSheetRow as i } from "../../components/content-controls/toolbar-sheet-row.mjs";
import { ImageBubbleMenu as a } from "./image-bubble-menu.mjs";
import { InsertImageViaLink as o } from "./insert-image-via-link.mjs";
import { FileSelectorModal as s, FileSourceEnum as c, FileTypeEnum as l } from "@systemeio/file-manager";
import { useEditorState as u } from "@tiptap/react";
import { Fragment as d, useMemo as f, useState as p } from "react";
import { Fragment as m, jsx as h, jsxs as g } from "react/jsx-runtime";
import { Image01Icon as _ } from "@systemeio/icons";
//#region src/extensions/image-extension/use-image-extension-toolbar.tsx
var v = (v, y) => {
	let { t: b } = t(), x = y?.fileSource ?? c.TextEditor, [S, C] = p(!1), w = !u({
		editor: v,
		selector: ({ editor: e }) => ({ isEditable: e?.options.editable ?? !1 })
	})?.isEditable;
	return f(() => {
		let t = (t) => {
			if (!v) return null;
			let r = () => v.chain().focus().run();
			if (!t) return r();
			let i = new Image();
			i.src = t, i.onerror = () => {
				e.error(b("image_error")), r();
			}, i.onload = () => {
				let e = i.naturalWidth, r = i.naturalHeight;
				v.chain().focus().setImage({
					src: t,
					imageMode: n.BlockCenter,
					containerWidth: "auto",
					width: e,
					height: r
				}).run(), C(!1);
			};
		};
		return {
			toolbarRender: /* @__PURE__ */ g("div", {
				className: "flex items-center",
				children: [/* @__PURE__ */ h(r, {
					disabled: w,
					label: b("image"),
					onClick: () => C(!0),
					children: /* @__PURE__ */ h(_, {})
				}), /* @__PURE__ */ h(o, {
					handleSetImage: t,
					isDisabled: w
				})]
			}),
			sheetRender: /* @__PURE__ */ g(m, { children: [/* @__PURE__ */ h(i, {
				disabled: w,
				icon: /* @__PURE__ */ h(_, {}),
				label: b("image"),
				onClick: () => C(!0)
			}), /* @__PURE__ */ h(o, {
				asSheetRow: !0,
				handleSetImage: t,
				isDisabled: w
			})] }),
			additionalRender: /* @__PURE__ */ g(d, { children: [/* @__PURE__ */ h(s, {
				initialSearchFilters: {
					name: "",
					source: [x],
					type: [l.Image, l.ImageOther]
				},
				opened: S,
				onClose: () => C(!1),
				onSelect: ({ path: e }) => t(e),
				uploadingFromSource: x,
				disabledFileTypeSelect: !0
			}), /* @__PURE__ */ h(a, {
				editor: v,
				fileSource: x,
				options: y
			})] })
		};
	}, [
		w,
		S,
		v,
		x,
		y,
		b
	]);
};
//#endregion
export { v as useImageExtensionToolbar };
